import { DRAWER_HEIGHT } from "@constants/Drawer";

export function set(
  element: HTMLElement | null,
  styles: Partial<CSSStyleDeclaration>
) {
  if (!element) return;
  Object.assign(element.style, styles);
}

export const findNearestSnapPoint = (
  value: number,
  minHeight: number,
  maxHeight: number
): number => {
  const snapPointArr = [
    0,
    minHeight,
    maxHeight,
    DRAWER_HEIGHT.DEFAULT_OPEN_PERCENT,
  ];
  let nearest: number = snapPointArr[0];
  let minDiff = Infinity;

  snapPointArr.forEach(p => {
    const diff = Math.abs(p - value);
    if (diff < minDiff) {
      minDiff = diff;
      nearest = p;
    }
  });

  return nearest;
};
